import './_footer.scss';
// import logo from '../../assets/Nandus.png';

const Footer = () => {
  return (
    <footer className="footer">
      {/* bottom footer */}
      <div className="copyright">
        <p>2022 © All Rights Reserved by Nandus</p>
      </div>
    </footer>
  );
};

export default Footer;
